<template>
  <b-container fluid>
    <b-row v-if="mobile || tablet" class="mb-3">
      <b-col md="12">
        <div class="d-flex align-items-center">
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="monthYear"
            format="MM/YYYY"
            placeholder="Выберите месяц"
            data-vv-as="Месяц год"/>
          <b-button
            :disabled="!monthYear"
            type="button"
            variant="success"
            class="text-center action-button mr-3"
            @click="loadPackageStatistic()">Загрузить
          </b-button>
          <!-- b-button
            :disabled="!monthYear"
            type="button"
            variant="outline-success"
            class="text-center action-button"
            @click="getPackageStatisticExcel({ 'date': monthYear, 'ctm_id': getCtmId })">В excel
          </b-button -->
        </div>
      </b-col>
    </b-row>
    <b-row v-if="mobile || tablet" class="mb-3">
      <b-col md="12">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>

    <b-row v-if="desktop || largeDesktop" class="mb-4">
      <b-col md="8">
        <div class="d-flex align-items-center">
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="monthYear"
            format="MM/YYYY"
            placeholder="Выберите месяц"
            data-vv-as="Месяц год"/>
          <b-button
            :disabled="!monthYear"
            type="button"
            variant="success"
            class="text-center action-button mr-3"
            @click="loadPackageStatistic()">Загрузить отчет
          </b-button>
          <!-- b-button
            :disabled="!monthYear"
            type="button"
            variant="outline-success"
            class="text-center action-button"
            @click="getPackageStatisticExcel({ 'date': monthYear, 'ctm_id': getCtmId })">Выгрузить в excel
          </b-button -->
        </div>
      </b-col>
      <b-col md="4">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close" @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="selectDealerOptions.length > 0">
      <b-col md="3">
        <b-form-select @input="selectDealer" v-model="selectedDealer" :options="selectDealerOptions" class="mb-3">
          <template #first>
            <b-form-select-option :value="null" disabled>Выберите дилера</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col md="9" class="d-flex align-items-start justify-content-end">
        <b-dropdown right variant="success">
          <template v-slot:button-content>
            Выгрузить в Excel
          </template>
          <b-dropdown-item v-for="dealer in selectDealerOptions"
                           @click="downloadDealerExcel(dealer.value)"
                           :key="dealer.value">
            <p class="mb-0 download-report">{{dealer.text}} <i class="fas fa-file-download"></i></p>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>

    <div v-if="this.packageStatistic && this.packageStatistic.length " class="filtered-items-number">Записи с
      {{ currentPage === 1 ? this.setFirstItem() : ((currentPage-1)*this.pageOptionSelected)+1 }} до
      {{ this.calcItems() }} из {{ this.parsedPackageStatistic.length }} (отфильтровано из {{
      this.packageStatistic.length }} записей)
    </div>

    <b-row>
      <b-col md="9" sm="9" class="mb-2">
        <b-table
          :striped="striped"
          :stacked="stacked"
          :fixed="fixed"
          hover
          show-empty
          id="data_table"
          :fields="fields"
          :items="parsedPackageStatistic"
          :busy="isBusy"
          :no-provider-paging="true"
          :no-provider-sorting="true"
          :no-provider-filtering="true"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          class="data_table_report mt-3 blue"
          empty-text="Нет данных в таблице"
          empty-filtered-text="Нет данных по вашему запросу">

          // загрузчик
          <div slot="table-busy" class="text-center text-secondary my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Загрузка...</strong>
          </div>

          // клиент
          <template v-slot:head(client)="data">
            {{ data.label }}
          </template>

          // инн
          <template v-slot:head(inn)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(inn)="row">
            <div v-if="mobile || tablet || desktop">{{ row.item.inn }} / {{ row.item.kpp }}</div>
            <div v-if="largeDesktop">{{ row.item.inn }}</div>
          </template>

          // кпп
          <template v-slot:head(kpp)="data">
            {{ data.label }}
          </template>

          // количество
          <template v-slot:head(quantity)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(quantity)="row">
            <div v-for="(item, index) in row.item.detail" class="text-center"
                 :key="index"
                 :style="{ borderBottom : index !== row.item.detail.length-1 ? '1px solid #dee2e6' : '',
                           paddingBottom : index !== row.item.detail.length-1 ? '5px' : '',
                           paddingTop: index !== 0 ? '5px' : '',
                           marginRight: '-5px',
                           marginLeft: '-5px' }">
              {{ item.count }}
            </div>
          </template>

          // расшифровка
          <template v-slot:head(detail)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(detail)="row">
            <div v-if="mobile || tablet || desktop">
              <div v-for="(item, index) in row.item.detail"
                   :key="index"
                   :style="{ borderBottom : index !== row.item.detail.length-1 ? '1px solid #dee2e6' : '',
                           paddingBottom : index !== row.item.detail.length-1 ? '5px' : '',
                           paddingTop: index !== 0 ? '5px' : '',
                           marginRight: '-5px',
                           marginLeft: '-5px',
                           paddingLeft: '5px' }">
                <div class="details-wrapper" v-if="isSelected(item)"><b>{{ item.caption }}</b> <span class="details-wrapper-count">{{ item.count }}</span></div>
                <div class="details-wrapper" v-else>{{ item.caption }} <span class="details-wrapper-count">{{ item.count }}</span></div>
              </div>
            </div>

            <div v-if="largeDesktop">
              <div v-for="(item, index) in row.item.detail"
                   :key="index"
                   :style="{ borderBottom : index !== row.item.detail.length-1 ? '1px solid #dee2e6' : '',
                           paddingBottom : index !== row.item.detail.length-1 ? '5px' : '',
                           paddingTop: index !== 0 ? '5px' : '',
                           marginRight: '-5px',
                           marginLeft: '-5px',
                           paddingLeft: '5px' }">
                <b v-if="isSelected(item)">{{ item.caption }}</b>
                <span v-else>{{ item.caption }}</span>
              </div>
            </div>

          </template>

          // детализация
          <template v-slot:head(details)="data">
            {{ data.label }}
          </template>
          <template v-slot:cell(details)="row">
            <div class="text-center">
              <b-button
                v-if="desktop || largeDesktop"
                :disabled="!monthYear"
                @click="getDetails({ 'date': monthYear, 'ctm_id': row.item.ctm_id, 'name': row.item.client })"><i
                class="fas fa-download"></i>
              </b-button>
              <div class="download-details" v-if="tablet || mobile">
                <i class="fas fa-download"></i>
              </div>
            </div>
          </template>
        </b-table>

        <div class="main-footer">
          <b-form inline>
            <label v-if="desktop || largeDesktop" class="mr-3">Показать</label>
            <b-form-select :options="pageOptions" v-model="perPage" @change="saveOptionSelected"/>
          </b-form>
          <b-pagination align="center"
                        prev-text="&lt;"
                        first-text="&lt;&lt;"
                        next-text="&gt;"
                        last-text="&gt;&gt;"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        v-model="currentPage"
                        class="my-6">
          </b-pagination>
        </div>
      </b-col>
      <b-col md="3" sm="3" class="mb-2 pt-7">
        <b-form-checkbox
          v-if="packageStatistic && packageStatistic.length > 0"
          class="total"
          id="checkbox-1"
          v-model="status"
          name="checkbox-1"
          value="accepted"
          @change="toggleSelection"
          unchecked-value="not_accepted"
        >
          <b>Выделить все</b>
        </b-form-checkbox>
        <b-form-group :key="checkboxFormKey" v-if="packageStatistic && packageStatistic.length > 0">
          <b-form-checkbox
            class="select-total"
            v-for="option in options"
            v-model="selectVal.caption"
            :key="option.key"
            :value="option.value"
            @change="changeOptionCounter"
            name="flavour-1"
          >
            <div class="d-flex justify-content-between align-items-center">
              <div class="option-text">{{ option.text }}</div>
              <b-badge class="option-count" v-if="option.counter > 0" variant="success">{{ option.counter }}</b-badge>
            </div>
          </b-form-checkbox>
        </b-form-group>
        <hr v-if="packageStatistic && packageStatistic.length > 0">
        <div class="total-wrapper d-flex justify-content-between align-items-center">
          <div>Итого тарифицируемых пакетов:</div>
          <b-badge variant="primary">{{ totalSelected }}</b-badge>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'PackageStatistic.vue',
  components: {},
  data () {
    return {
      fields: [],
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      sortBy: null,
      sortDesc: true,
      sortDirection: 'desc',
      pageOptionSelected: 10,
      filter: null,
      monthYear: null,
      options: [],
      selectVal: {
        caption: []
      },
      status: 'accepted',
      striped: false,
      stacked: false,
      fixed: false,
      responsive: false,
      totalSelected: null,
      selectDealerOptions: [],
      selectedDealer: null,
      packageStatistic: null,
      totals: null,
      total: 0,
      checkboxFormKey: Math.random()
    }
  },
  watch: {
    mobile (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    tablet (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    desktop (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    largeDesktop (to) {
      if (to) {
        this.setTableFields()
        this.$root.$emit('bv::refresh::table', 'data_table')
      }
    },
    allDealersPackageStatistic (val) {
      for (let i = 0; i < val.length; i++) {
        this.selectDealerOptions.push({ value: val[i].dealer_id, text: val[i].dealer_name })
      }
      if (this.selectDealerOptions.length === 1) {
        this.selectedDealer = this.selectDealerOptions[0].value
        this.selectDealer(this.selectDealerOptions[0].value)
      }
    }
  },
  beforeMount () {},
  mounted () {
    this.setTableFields()
  },
  methods: {
    ...mapActions('packageStatistic', [
      'getPackageStatistic',
      'getPackageStatisticExcel',
      'getDetails'
    ]),
    ...mapMutations('packageStatistic', [
      'setTotal',
      'setTotals',
      'setPackageStatistic'
    ]),
    setTableFields () {
      if (this.mobile) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН / КПП', sortable: false },
          { key: 'detail', label: 'Расшифровка / Количество', sortable: false },
          { key: 'details', label: 'Дет.', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
      if (this.tablet) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН / КПП', sortable: false },
          { key: 'detail', label: 'Расшифровка / Количество', sortable: false },
          { key: 'details', label: 'Детализация', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
      if (this.desktop) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН / КПП', sortable: false },
          { key: 'detail', label: 'Расшифровка / Количество', sortable: false },
          { key: 'details', label: 'Детализация', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
      if (this.largeDesktop) {
        this.fields = [
          { key: 'client', label: 'Клиент', sortable: false },
          { key: 'inn', label: 'ИНН', sortable: false },
          { key: 'kpp', label: 'КПП', sortable: false },
          { key: 'quantity', label: 'Количество', sortable: false },
          { key: 'detail', label: 'Расшифровка', sortable: false },
          { key: 'details', label: 'Детализация', sortable: false, tdClass: 'align-middle' }
        ]
        this.striped = true
        this.stacked = false
        this.fixed = false
        this.responsive = true
      }
    },
    setFirstItem () {
      if (this.parsedPackageStatistic.length < 1) {
        return 0
      } else {
        return 1
      }
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    calcItems () {
      if (this.currentPage === 1) {
        if ((this.currentPage) + this.pageOptionSelected < this.parsedPackageStatistic.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.parsedPackageStatistic.length
        }
      } else {
        if (((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected < this.parsedPackageStatistic.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.parsedPackageStatistic.length
        }
      }
    },
    downloadDealerExcel (dealerId) {
      this.getPackageStatisticExcel({ date: this.monthYear, ctm_id: this.getCtmId, dealerId: dealerId })
    },
    selectDealer (event) {
      const dealer = this.allDealersPackageStatistic.find((item) => {
        return item.dealer_id === event
      })
      this.packageStatistic = dealer.data_clients
      this.total = dealer.total
      this.totals = dealer.totals
      this.totalRows = this.packageStatistic.length
      this.options = []
      this.selectVal.caption = []
      this.checkboxFormKey += 1
      for (let i = 0; i < this.totals.length; i++) {
        this.options.push({ text: this.totals[i].caption, value: this.totals[i].caption, counter: 0, key: Math.random() })
        this.selectVal.caption.push(this.totals[i].caption)
      }
      this.$nextTick(() => {
        this.toggleSelection('not_accepted')
        this.toggleSelection('accepted')
      })
    },
    loadPackageStatistic () {
      this.options = []
      this.selectDealerOptions = []
      this.selectedDealer = null
      this.getPackageStatistic({
        date: this.monthYear,
        ctm_id: this.getCtmId
      })
    },
    onFiltered (packageStatistic) {
      this.$nextTick(() => {
        if (packageStatistic.length === 0) {
          this.totalRows = null
        } else {
          this.totalRows = packageStatistic.length
        }
      })
      this.currentPage = 1
    },
    clearField () {
      this.filter = ''
    },
    changeOptionCounter () {
      this.$nextTick(() => {
        if (this.selectVal.caption.length < this.totals.length) {
          this.status = 'not_accepted'
        } else if (this.selectVal.caption.length === this.totals.length) {
          this.status = 'accepted'
        }
        this.options.forEach(function (v) { v.counter = 0 })
        if (this.packageStatistic && this.packageStatistic.length > 0) {
          this.packageStatistic.forEach((val) => {
            for (let i = 0; i < val.detail.length; i++) {
              for (let j = 0; j < this.selectVal.caption.length; j++) {
                if (val.detail[i].caption === this.selectVal.caption[j]) {
                  const opt = this.options.filter(option => option.text === this.selectVal.caption[j])
                  opt[0].counter += parseInt(val.detail[i].count)
                }
              }
            }
          })
        }
        this.totalRows = this.parsedPackageStatistic.length
        this.totalSelected = this.options.reduce((sum, current) => {
          return sum + current.counter
        }, 0)
      })
    },
    toggleSelection (toggle) {
      if (toggle === 'not_accepted') {
        this.selectVal.caption = []
        this.changeOptionCounter(null)
      } else if (toggle === 'accepted') {
        this.selectVal.caption = []
        for (let i = 0; i < this.totals.length; i++) {
          this.selectVal.caption.push(this.totals[i].caption)
        }
        this.changeOptionCounter(null)
      }
    },
    isSelected (item) {
      const s = this.selectVal.caption.filter(ind => {
        return item.caption === ind
      })
      return s.length > 0
    }
  },
  computed: {
    ...mapState(
      {
        allDealersPackageStatistic: state => state.packageStatistic.allDealersPackageStatistic,
        // packageStatistic: state => state.packageStatistic.packageStatistic,
        // totals: state => state.packageStatistic.totals,
        // total: state => state.packageStatistic.total,
        isBusy: state => state.packageStatistic.isBusy,
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop
      }
    ),
    getCtmId () {
      return JSON.parse(localStorage.getItem('castleUserInfo')).company.company_profile.ctm_id
    },
    parsedPackageStatistic () {
      if (this.packageStatistic && this.packageStatistic.length > 0 && this.selectVal.caption.length > 0) {
        return JSON.parse(JSON.stringify(this.packageStatistic)).filter(item => {
          for (let i = 0; i < item.detail.length; i++) {
            for (let j = 0; j < this.selectVal.caption.length; j++) {
              let keep = true
              keep = keep && (item.detail[i].caption === this.selectVal.caption[j])
              if (keep) {
                return keep
              }
            }
          }
        })
      } else if (this.packageStatistic && this.packageStatistic.length > 0) {
        return this.packageStatistic
      } else {
        return []
      }
    },
    fieldKeys () {
      return ['caption']
    }
  },
  destroyed () {
    this.setTotal()
    this.setTotals()
    this.setPackageStatistic()
  }
}
</script>

<style lang="scss" scoped>
  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .input-group {
    .form-control:not(:last-child), .custom-select:not(:last-child) {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      font-size: 14px;
      height: 40px;
    }
  }

  .action-button {
    height: 40px;
    width: 170px;
  }

  .totals {
    font-size: 14px;
    border-bottom: 1px solid #dee2e6;
    padding: 5px;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  .filtered-items-number {
    font-size: 14px;
  }

  .details-wrapper {
    width: 100%;
    display: inline-block;
    position: relative;
    .details-wrapper-count {
      position: absolute;
      right: 8px;
    }
  }

  .button-end {
    display: flex;
    justify-content: flex-end;
  }

  .download-report {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      color: #6c6c6c;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #data_table {
      font-size: 10px;
    }
    .total {
      font-size: 10px;
    }
    .total-wrapper {
      font-size: 10px;
    }
    .select-total {
      font-size: 10px;
    }
    .main-footer {
      font-size: 10px;
    }
    .custom-select {
      font-size: 10px;
    }
    .option-count {
      position: absolute;
      right: 0;
      top: 3px;
    }
    .option-text {
      position: relative;
      top: 3px;
    }
    .download-details {
      font-size: 14px;
      color: #78909c;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1439px) {
    .total {
      font-size: 14px;
    }
    .total-wrapper {
      font-size: 14px;
    }
    .select-total {
      font-size: 14px;
    }
    .option-count {
      position: absolute;
      right: 0;
    }
  }

  @media screen and (min-width: 1440px) {
    .option-count {
      position: absolute;
      right: 0;
    }
  }
</style>
